module.exports = __webpack_public_path__ + "sa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/sa.svg
// module id = 787
// module chunks = 0